import { ApiException } from "./models/api-exception";
export const isErrorResponse = (object)=>{
    return object && object['Status'] === 'Error';
};
export const httpResult = async (promise)=>{
    try {
        return {
            kind: 'result',
            value: await promise(),
            status: 200
        };
    } catch (error) {
        if (isErrorResponse(error)) return {
            kind: 'failed',
            status: error.HttpStatusCode
        };
        if (ApiException.isApiException(error)) return {
            kind: 'failed',
            status: error.status
        };
        console.error(error);
        return {
            kind: 'failed',
            status: 500
        };
    }
};
export const extendedHttpResult = async (promise)=>{
    try {
        return {
            kind: 'result',
            value: await promise(),
            status: 200
        };
    } catch (error) {
        if (isErrorResponse(error)) return {
            kind: 'failedWithMessage',
            message: error.Message,
            status: error.HttpStatusCode
        };
        if (ApiException.isApiException(error)) return {
            kind: 'failedWithMessage',
            message: error.message,
            status: error.status
        };
        console.error(error);
        return {
            kind: 'failed',
            status: 500
        };
    }
};
export const pipeRevivers = (revivers)=>(key, value)=>revivers.reduce((v, f)=>f(key, v), value);
export const upperCase = (prop)=>(key, value)=>key === prop ? value.toUpperCase() : value;
export const parseDate = (prop)=>(key, value)=>key === prop ? new Date(Date.parse(value)) : value;
